import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { supabaseClient } from "../../component/supabaseClient";
import { useNavigate } from "react-router-dom";
import { MuiTheme } from "../../styles/MuiDataTableStyle";
import MUIDataTable from "mui-datatables";
import LoadingModal from "../../component/modals/LoadingModal";
import { LuTrash2 } from "react-icons/lu";
import {MdEdit} from "react-icons/md";

import {
  textLabels,
  downloadOptions,
  sortFunction,
} from "../../utils/MuiTableOptions";
import { GoBackButton } from "../../component/GoBackButton";
import { errAndMsg } from "../../utils/MsgAlert";

function TipoProducto() {
  const navigate = useNavigate();

  const [tipoProducto, setTipoProducto] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getTipoProducto = async () => {
      const { data, error } = await supabaseClient
        .from("tipoProducto")
        .select()
        .order("tipoProdId", { ascending: true });
      if (error) {
        errAndMsg("Error", error.message, error.code);
      } else {
        data && setTipoProducto(data);
      }
    };
    getTipoProducto();
  }, []);

  const editTipoProducto = (event) => {
    // eslint-disable-next-line array-callback-return
    tipoProducto?.map((tp) => {
      if (tp.tipoProdId === parseInt(event.currentTarget.id)) {
        navigate("editar-tipo-producto", {
          state: {
            tipoProducto: tp,
          },
        });
      }
    });
  };

  const columns = [
    {
      name: "tipoProdId",
      label: "Id",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta) => (
          <th style={{ backgroundColor: "#f0f0f0", textAlign: "center" }}>
            {columnMeta.label}
          </th>
        ),
      },
    },
    {
      name: "descripcion",
      label: "Descripcion",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta) => (
          <th style={{ backgroundColor: "#f0f0f0", textAlign: "center" }}>
            {columnMeta.label}
          </th>
        ),
      },
    },
    {
      name: "acciones",
      label: "Acciones",
      options: {
        customHeadRender: (columnMeta) => (
          <th style={{ backgroundColor: "#f0f0f0", textAlign: "center" }}>
            {columnMeta.label}
          </th>
        ),
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <div>
              <LuTrash2
                id={tipoProducto[dataIndex].tipoProdId}
                style={{ cursor: "pointer" }}
                className="crud__table__icon"
                alt="Item menú"
                // onClick={deleteTipoProducto}
              />
              <MdEdit
                id={tipoProducto[dataIndex].tipoProdId}
                style={{ cursor: "pointer" }}
                className="crud__table__icon"
                alt="Item menú"
                onClick={editTipoProducto}
              />
            </div>
          );
        },
        filter: false,
        sort: false,
      },
    },
  ];

  const options = {
    searchOpen: true,
    textLabels,
    downloadOptions,
    filter: true,
    selectableRows: "none",
    fixedHeader: false,
    filterType: "dropdown",
    responsive: "standard",
    customSort: sortFunction,
    draggableColumns: { enabled: true },
  };

  return (
    <>
      <ThemeProvider theme={MuiTheme}>
        <div className="crud">
        <div className="crud__title">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <GoBackButton />
              <div style={{ width: "100%" }}>
                <h3>Tipos de Productos</h3>
              </div>
            </div>
            <hr />
          </div>
          <MUIDataTable
            title={"Listado de tipos de Productos"}
            data={tipoProducto}
            columns={columns}
            options={options}
          />
          <div className="crud__rigth-buttons-container">
            <button
              className="btn btn-dark"
              onClick={() => {
                navigate("agregar-tipo-producto", {
                  state: { tipoProducto: false },
                });
              }}
            >
              Agregar nuevo tipo de producto
            </button>
          </div>
        </div>
        <LoadingModal
          text="Eliminando tipo de producto..."
          show={loading}
          setShow={setLoading}
        />
      </ThemeProvider>
    </>
  );
}

export default TipoProducto;
